// extracted by mini-css-extract-plugin
export default {"iconLink":"IconLink-module--iconLink--i44Fj","icon":"IconLink-module--icon--R29QA","link":"IconLink-module--link--mGQSp"};